import React from 'react';
import { TOP_FILMS } from '../data/mockData';
export function TopFilmsTable() {
  return <div className="bg-white rounded-xl soft-shadow overflow-hidden border border-gray-100" data-id="element-248">
      <div className="p-6 border-b border-gray-50" data-id="element-249">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-250">
          Top Performing Films
        </h2>
      </div>
      <div className="overflow-x-auto" data-id="element-251">
        <table className="w-full text-sm text-left" data-id="element-252">
          <thead className="text-xs text-gray-400 uppercase bg-gray-50/50" data-id="element-253">
            <tr data-id="element-254">
              <th className="px-6 py-4 font-medium" data-id="element-255">Rank</th>
              <th className="px-6 py-4 font-medium" data-id="element-256">Film</th>
              <th className="px-6 py-4 font-medium" data-id="element-257">Shows</th>
              <th className="px-6 py-4 font-medium" data-id="element-258">Tickets</th>
              <th className="px-6 py-4 font-medium" data-id="element-259">Revenue</th>
              <th className="px-6 py-4 font-medium" data-id="element-260">Occupancy</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-261">
            {TOP_FILMS.map(film => <tr key={film.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-262">
                <td className="px-6 py-4 font-medium text-gray-500" data-id="element-263">
                  #{film.rank}
                </td>
                <td className="px-6 py-4 font-semibold text-gray-900" data-id="element-264">
                  {film.title}
                </td>
                <td className="px-6 py-4 text-gray-600" data-id="element-265">{film.shows}</td>
                <td className="px-6 py-4 text-gray-600" data-id="element-266">{film.tickets}</td>
                <td className="px-6 py-4 font-medium text-gray-900" data-id="element-267">
                  {film.revenue}
                </td>
                <td className="px-6 py-4" data-id="element-268">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-269">
                    {film.occupancy}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}